import {
  addRequestBody, get,
  getData, ifOkToJson, isDataFine, post
} from './index'
import {bus} from '../../utils/bus'
import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-apartment`

class Api {
  addElectronicRecord (data) {
    return post(`${baseUrl}/chargeRecord/add`, data)
      .then(ifOkToJson)
      .then(getData)
  }
  getElectronicRecordPage (requestBody) {
    return post(`${baseUrl}/chargeRecord/getPage`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }
  getElectronicRecordById (id) {
    return get(`${baseUrl}/chargeRecord/getByCode/${id}`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  deleteElectronicRecordByIds (ids) {
    return post(`${baseUrl}/chargeRecord/deleteByCodes`, [ids])
      .then(ifOkToJson)
      .then(isDataFine)
  }
  updateElectronicRecordByIds (data) {
    return post(`${baseUrl}/chargeRecord/update`, data)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  getPayRecordPage (requestBody) {
    return post(`${baseUrl}/payRecord/getPage`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }

  getEnterpriseList () {
    return post(`${baseUrl2}/enterpriseInfo/getEnterpriseList`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  exportElectronicRecordData (requestBody) {
    return addRequestBody(
      `${baseUrl}/chargeRecord/exportData?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}`, requestBody
    )
  }
  exportElectronicRecord (requestBody) {
    return addRequestBody(
      `${baseUrl}/chargeRecord/exportRecord?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}`, requestBody
    )
  }
  importElectronicRecord () {
    return `${baseUrl}/chargeRecord/import`
  }

  getElectricOverviewSummary (requestBody) {
    return post(`${baseUrl}/chargeRecord/getOverviewSummary`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }

  getElectricOverviewList (requestBody) {
    return post(`${baseUrl}/chargeRecord/getOverviewList`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }
}

const api = new Api()
export default api
export {api}



// WEBPACK FOOTER //
// ./src/view/api/electronic-control.js